import UISettings from '../utils/UISettings';
import { userDetailsLoadingFinished, userDetailsLoadingStarted } from './ducks/userDetails';

export function initGroupCallListener(store) {

  function handleGroupCallLoading(groupCallIsLoading) {
    // Because sometimes happens that this function is called before window.App.settings is updated
    setTimeout(() => {
      if (groupCallIsLoading) {
        store.dispatch(userDetailsLoadingStarted());
      } else {
        store.dispatch(userDetailsLoadingFinished(
          window.App.settings && window.App.settings.get('userDetails')
        ));
      }
    }, 0);
  }

  UISettings.watchChanges('groupcallIsLoading', UISettings.Type.USER, handleGroupCallLoading);
}
